<!-- tabindex -1: Tab between popup stops is routed by the wrapper's DropdownPopupLayout. -->
<span class="k-searchbox">
    <input
        #searchInput
        type="text"
        tabindex="-1"
        autocomplete="off"
        class="k-input-inner"
        [value]="text()"
        [attr.placeholder]="'SearchBar.PlaceHolder' | translate"
        [attr.aria-label]="'SearchBar.PlaceHolder' | translate"
        (input)="onInput(searchInput.value)"
        (keydown)="onInputKeydown($event)"
        (keypress)="$event.stopPropagation()"
        (pointerdown)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        (click)="$event.stopPropagation()"
    />
    <button
        #clearButton
        type="button"
        tabindex="-1"
        class="k-icon"
        [class.wk-ddlw-search-clear]="text()"
        [disabled]="!text()"
        [attr.aria-label]="text() ? clearLabel() || ('SearchBar.ClearSearch' | translate) : ('SearchBar.PlaceHolder' | translate)"
        (keydown)="onButtonKeydown($event)"
        (mousedown)="$event.stopPropagation()"
        (click)="$event.stopPropagation(); clear()"
    ></button>
</span>
